module.exports = __webpack_public_path__ + "img/xlsx.a5142320.png";